import React, { useEffect, useState } from "react";
import { Table, Container } from "react-bootstrap";
import "./WebCommon.scss";
import { LeftArrow, RightArrow } from "../../../Assets/svgIcons";
import { Link } from "react-router-dom";

const RoyalityReport = ({ symbolRoyalty }) => {
  

  const royaltyData = Object.entries(symbolRoyalty)
  return (
    <>
    {royaltyData?.length ? <section className="page_design">
      <Container>
        {/* <div className="backbtn mb-3">
          <Link to="/account"><span><LeftArrow /></span> Back</Link>
        </div> */}
        <div className="page_design_in">
          <div className="page_design_head">
            <h2>Royalty Report</h2>
          </div>
          <div className="page_design_body">
            <Table responsive>
              <thead>
                <tr>
                  <th></th>
                  <th>Sr No.</th>
                  <th>Symbol Name</th>
                  {/* <th>Royalty distribution date</th> */}
                  <th>Royalty received</th>
                  {/* <th>Time Period</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {royaltyData.map(([symbol, value], index) =>
                  // item.data.map((entry, index) => (

                    <tr key={`${symbol}-${index}`}>
                      <td></td>
                      <td>{index + 1}</td>
                      <td>{symbol}</td>
                      {/* <td>{entry.date}</td> */}
                      <td>{value}</td>
                      <td></td>
                    </tr>
                  // ))
                )}
                {/* {data.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td></td>
                      <td>{index + 1}</td>
                      {/* <td>{item.sr}</td> */}
                {/* <td>{item.feeType}</td>
                      <td>{item.balance}</td>
                      <td>{item.sellAmount}</td>
                      <td>{item.biddingAmount}</td>
                      <td></td>
                    </tr>
                  );
                })} */}
              </tbody>
            </Table>
            {/* <div className="custom_pagination">
              <button className="prev_page">
                <LeftArrow />
              </button>
              <ul>
                <li>
                  <button>1</button>
                </li>
                <li>
                  <button className="active">2</button>
                </li>
                <li>
                  <button>3</button>
                </li>
                <li>
                  <button>...</button>
                </li>
                <li>
                  <button>12</button>
                </li>
              </ul>
              <button className="next_page">
                <RightArrow />
              </button>
            </div> */}
          </div>
        </div>
      </Container>
    </section>: ''}
    </>
  );
};

export default RoyalityReport;
